import { useState, useRef, useEffect } from 'react';
import { Plus, X, Camera, Image, FileText, DollarSign, Hammer, Users } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { cn } from '../../utils/formatters';

const quickActions = [
  { name: 'Nuevo Proyecto', href: '/projects/new', icon: Hammer, roles: ['admin', 'superadmin'] },
  { name: 'Nuevo Presupuesto', href: '/budgets/new', icon: FileText, roles: ['admin', 'superadmin'] },
  { name: 'Nuevo Gasto', href: '/expenses/new', icon: DollarSign, roles: ['admin', 'superadmin', 'worker'] },
  { name: 'Nuevo Cliente', href: '/clients/new', icon: Users, roles: ['admin', 'superadmin'] },
  { name: 'Subir Foto', href: '#', icon: Camera, roles: ['admin', 'superadmin', 'worker'], action: 'camera' },
  { name: 'Escanear Ticket', href: '#', icon: Image, roles: ['admin', 'superadmin', 'worker'], action: 'scan' },
];

export function FloatingActionButton() {
  const location = useLocation();
  const { user } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const fabRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (fabRef.current && !fabRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const availableActions = quickActions.filter(action =>
    user && action.roles.includes(user.role)
  );

  if (availableActions.length === 0) return null;

  return (
    <div className="fixed fab-safe-bottom right-6 z-50 md:hidden" ref={fabRef}>
      <div className="flex flex-col-reverse items-end gap-3">
        {isOpen && availableActions.map((action, index) => (
          <button
            key={action.name}
            onClick={() => {
              if (action.action === 'camera') {
                // TODO: Abrir cámara
                console.log('Abrir cámara');
              } else if (action.action === 'scan') {
                // TODO: Escanear ticket
                console.log('Escanear ticket');
              }
              setIsOpen(false);
            }}
            className="fab w-12 h-12 bg-white dark:bg-secondary-800 shadow-lg flex items-center justify-center gap-2 px-4 rounded-full border border-secondary-200 dark:border-secondary-700 animate-in slide-in-from-bottom-2 fade-in"
            style={{ transitionDelay: `${index * 50}ms` }}
          >
            <action.icon className="w-5 h-5 text-secondary-700 dark:text-secondary-300" />
            <span className="text-sm font-medium text-secondary-700 dark:text-secondary-300 whitespace-nowrap">
              {action.name}
            </span>
          </button>
        ))}

        <button
          onClick={() => setIsOpen(!isOpen)}
          className="fab relative z-10"
          aria-label={isOpen ? 'Cerrar acciones rápidas' : 'Abrir acciones rápidas'}
          aria-expanded={isOpen}
        >
          {isOpen ? <X className="w-6 h-6" /> : <Plus className="w-6 h-6" />}
        </button>
      </div>
    </div>
  );
}